import { render } from "./rewardPoints.vue?vue&type=template&id=4d1a9c48&scoped=true"
import script from "./rewardPoints.vue?vue&type=script&lang=js"
export * from "./rewardPoints.vue?vue&type=script&lang=js"

import "./rewardPoints.vue?vue&type=style&index=0&id=4d1a9c48&lang=scss&scoped=true"
import "./rewardPoints.vue?vue&type=style&index=1&id=4d1a9c48&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1a9c48"]])

export default __exports__